import { inputBaseClasses } from "@mui/material/InputBase";
import { selectClasses } from "@mui/material/Select";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";

const filterSelectStyles = {
  width: "fit-content",
  height: "28px",
  fontSize: "13px",
  fontWeight: "500",
  [`&.${inputBaseClasses.root}`]: {
    borderRadius: theme => `${theme.shape.borderRadius * 0.5}px`,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme => theme.palette.system[50],
      border: "none !important"
    },
    "&:has([aria-expanded='true'])": {
      backgroundColor: theme => theme.palette.tertiary[100],
      color: theme => theme.palette.primary[500],
      [`& .${selectClasses.icon} path`]: {
        stroke: theme => theme.palette.primary[500]
      }
    }
  },
  [`&.${inputBaseClasses.root} .${selectClasses.icon}`]: {
    transform: "translateX(10px) scale(0.7)"
  },
  [`&.${inputBaseClasses.root}:has([aria-expanded='true']) .${selectClasses.icon}`]: {
    transform: "translateX(10px) scale(0.7) rotate(180deg)"
  },
  [`&.${inputBaseClasses.root} .${selectClasses.select}`]: {
    paddingRight: theme => theme.spacing(1.5)
  },
  [`&.${inputBaseClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    border: "none !important"
  },
  [`& .${formControlClasses.root}`]: {
    width: "fit-content"
  }
};

const filterMenuStyles = {
  "& .MuiTypography-root": {
    fontSize: "14px"
  }
};

const filterMenuPaperStyles = {
  width: "fit-content",
  maxHeight: "300px"
};

export { filterSelectStyles, filterMenuStyles, filterMenuPaperStyles };
